exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/modals/tipo-activo-fijo-modal/tipo-activo-fijo-modal.component.css
// module id = ../../../../../src/app/components/modals/tipo-activo-fijo-modal/tipo-activo-fijo-modal.component.css
// module chunks = main